<template>
  <div class="absolute w-full h-full top-0 left-0 top-0 text-center overflow-visible">
    <div class="progress">{{ progress }}%</div>
    <div class="scan-light" :style="{ bottom: `${progress - 4}%` }"></div>
  </div>
</template>

<script>
export default {
  name: 'ScanProgress',
  props: {
    progress: Number,
  },
};
</script>

<style lang="scss" scoped>
.progress {
  @apply relative font-bold mx-auto pl-2;
  font-size: 60px;
  top: 30%;
  background: linear-gradient(to right, #2245ff, #540deb);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.scan-light {
  @apply absolute left-0 right-0 mx-auto bg-contain;
  height: 12px;
  width: 203px;
  background: url('../../assets/FootScan/scan-beam.svg') no-repeat center;
}
</style>
